module.exports = __webpack_public_path__ + "static/sales@2x-b45edaba8ae8ae9dad578ed0db284985.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/contact-us/sales@2x.png
// module id = 2549
// module chunks = 221662759943617